module.exports = __webpack_public_path__ + "img/gangjiagong.509a4cba.jpg";